import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

interface IProps {
  total: number;
}

const ActionItemsByEquipmentTableSkeleton: React.FC<IProps> = ({ total }) => {
  return [...Array(total)].map(() => {
    const rowKey = uuidv4();
    return (
      <tr key={rowKey} className={style.bodyRow}>
        {[...Array(2)].map((_, i) => (
          <td key={`${rowKey}-${i}`}>
            <SkeletonBlock className={style.skeletonText} />
          </td>
        ))}
        <td className={style.iconColumn}>
          <SkeletonBlock className={style.skeletonIcon} />
        </td>
      </tr>
    );
  });
};

export default ActionItemsByEquipmentTableSkeleton;
